import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import "../styles.css";
import Autocomplete from "@mui/material/Autocomplete";
import { HOST_URL } from "../../../../config";
import axios from "axios";

function Address({ addressJSON, onChange = () => {} }) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [countryObject, setCountryObject] = useState([]);
  const [apiLoading, setApiLoading] = useState({
    country: false,
  });
  const loading = open && options.length === 0;

  useEffect(() => {
    getCountry();
  }, []);
  const getCountry = () => {
    setApiLoading({ ...apiLoading, country: true });
    const URL = `${HOST_URL}api/GetAllCountries`;
    axios
      .get(URL)
      .then((res) => {
        setCountryObject(res.data.countries);
        setApiLoading({ ...apiLoading, country: false });
      })
      .catch((err) => {
        console.log(err);
        setApiLoading({ ...apiLoading, country: false });
      });
  };
  const countryObjectOption = countryObject.map((countrylist) => {
    return {
      value: countrylist.key,
      label: `${countrylist.name} (${countrylist.key})`,
    };
  });
  return (
    <div>
      <div className="container-fluid _createaddcard ">
        <div className="row _createaddress ">
          <div className="col-12">
            <TextField
              label="Address Line 1"
              id="outlined-size-normal"
              defaultValue=""
              size="small"
              fullWidth
              value={addressJSON[0]?.Address1}
              onChange={(e) => {
                onChange(e.target.value, "Address1", "Addr");
              }}
            />
          </div>
        </div>
        {/* --------------- */}
        <div className="row _createaddress ">
          <div className="col-12">
            <TextField
              label="Address Line 2"
              id="outlined-size-normal"
              defaultValue=""
              size="small"
              fullWidth
              value={addressJSON[0]?.Address2}
              onChange={(e) => {
                onChange(e.target.value, "Address2", "Addr");
              }}
            />
          </div>
        </div>
        {/* ------------------ */}
        <div className="row _createaddress ">
          <div className="col-6">
            <TextField
              label="City/District"
              id="outlined-size-normal"
              defaultValue=""
              size="small"
              fullWidth
              value={addressJSON[0]?.City}
              onChange={(e) => {
                onChange(e.target.value, "City", "Addr");
              }}
            />
          </div>
          <div className="col-6">
            <TextField
              label=" State/Province"
              id="outlined-size-normal"
              defaultValue=""
              size="small"
              fullWidth
              value={addressJSON[0]?.State}
              onChange={(e) => {
                onChange(e.target.value, "State", "Addr");
              }}
            />
          </div>
        </div>
        {/* ------------------ */}
        <div className="row _createaddress ">
          <div className="col-6">
            <TextField
              label="Post Code"
              id="outlined-size-normal"
              defaultValue=""
              size="small"
              fullWidth
              value={addressJSON[0]?.PostCode}
              onChange={(e) => {
                onChange(e.target.value, "PostCode", "Addr");
              }}
            />
          </div>
          <div className="col-6">
            <Autocomplete
              id="asynchronous-demo"
              sx={{ width: "100%" }}
              open={open}
              onOpen={() => {
                setOpen(true);
              }}
              onClose={() => {
                setOpen(false);
              }}
              options={countryObjectOption}
              loading={loading}
              size="small"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Country"
                  value={addressJSON[0]?.Country}
                  onChange={(e) => {
                    onChange(e.target.value, "Country", "Addr");
                  }}
                  InputProps={{
                    ...params.InputProps,
                    // endAdornment: (
                    //   <React.Fragment>
                    //     {loading ? (
                    //       <CircularProgress color="inherit" size={20}
                    //       />
                    //     ) : null\}
                    //     {params.InputProps.endAdornment}
                    //   </React.Fragment>
                    // ),
                  }}
                />
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Address;
